
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.572 7.74H18.43L21.858.883h-5.143L13.287 7.74v10.286h10.285V7.74zM10.287 18.026V7.74H5.144L8.573.883H3.43L.001 7.74v10.286h10.286z","fill":"#748190"}})])
          )
        }
      }
    